/**
 * This function returns the value of a SASS theme variable.
 *
 * @example
 * ```typescript
 * const primaryColor = getThemeVariable('--primary-color');
 * ```
 *
 * @param variable - name of the variable to get
 * @param fallback - fallback value to return if the variable is not found
 *
 * @returns value of the variable
 */
export const getThemeVariable = (variable: string, fallback?: string): string => {
    const value = getComputedStyle(document.documentElement).getPropertyValue(variable);
    if (value) {
        return value.trim();
    }
    if (fallback) {
        return fallback;
    }
    return '';
};
